import { render, staticRenderFns } from "./InsuranceCompanyInformationViewer.vue?vue&type=template&id=1a0f4892"
import script from "./InsuranceCompanyInformationViewer.vue?vue&type=script&lang=js"
export * from "./InsuranceCompanyInformationViewer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports